import React from "react";
import { DialogActions, DialogContent, DialogTitle, MenuItem, Select } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { useDialog } from "../components/Dialogs/DialogProvider";

export default (props) => {
  const [, closeDialog] = useDialog();
  return (
    <>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          props.onSubmit(e.target[0].value, e.target[1].files);
        }}
      >
        <DialogTitle>Select File</DialogTitle>
        <DialogContent>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Select label={"Select merchant"} inputProps={{ required: true }}>
              {props.merchants.map((merchant) => (
                <MenuItem value={merchant.merchant_id}>{merchant.name}</MenuItem>
              ))}
            </Select>

            <Button variant={"contained"} color={"primary"} component="label">
              Select File
              <input type="file" hidden required multiple name={"files[]"} />
            </Button>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            variant={"outlined"}
            color={"secondary"}
            onClick={() => {
              closeDialog();
            }}
          >
            Cancel
          </Button>
          <Button variant={"outlined"} color={"primary"} type={"submit"}>
            Upload
          </Button>
        </DialogActions>
      </form>
    </>
  );
};
